import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import {
	getInventoryLevelEventQuantitySpcSamplingMethod,
	getInventoryLevelEventTotalWeightSpcSamplingMethod,
} from "src/components/views/erp/spcSamplingMethods/inventoryLevelEventSpcSamplingMethods.tsx";
import { defaultSpcSamplingMethods } from "src/tenantCustomizations/defaultTenantCustomizations.ts";
import { getSirmetAddShopOrdersToBatchDataGridCustomColumns } from "src/tenantCustomizations/tenants/sirmet/sirmetAddShopOrdersToBatchDataGridCustomColumns.tsx";
import { SirmetReceivedCustomerOrdersActionBarComponents } from "src/tenantCustomizations/tenants/sirmet/SirmetReceivedCustomerOrdersActionBarComponents.tsx";
import { SirmetShopOrderBatchContextMenuComponents } from "src/tenantCustomizations/tenants/sirmet/SirmetShopOrderBatchContextMenuComponents.tsx";
import { SirmetCustomerOrderContextMenuComponents } from "src/tenantCustomizations/tenants/sirmet/SirmetCustomerOrderContextMenuComponents.tsx";
import { SirmetSitePartRowContextMenuComponents } from "src/tenantCustomizations/tenants/sirmet/SirmetSitePartRowContextMenuComponents.tsx";
import {
	getLinjaterasSupplierSalesOrderIntegrationFormOption
} from "src/tenantCustomizations/tenants/sirmet/supplierSalesOrderIntegrations/linjaterasSupplierSalesOrderIntegrationFormOption.ts";

export const sirmetCustomizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
			accountingIntegrationEnabled: true,
			defaultCustomerType: "COMPANY",
			projectEnabled: false,
			deliveryPackageBundlingEnabled: true,
			configuratorEnabled: true,
		},
		tasks: {
			enabled: true,
		},
		documentsEnabled: true,
	},
	spcSamplingMethods: () => [
		...defaultSpcSamplingMethods,
		getInventoryLevelEventQuantitySpcSamplingMethod(),
		getInventoryLevelEventTotalWeightSpcSamplingMethod(),
	],
	erp: {
		purchase: {
			supplierSalesOrderIntegrationFormOptions: () => [
				getLinjaterasSupplierSalesOrderIntegrationFormOption(),
			],
		},
		sales: {
			receivedCustomerOrdersActionBarComponents: SirmetReceivedCustomerOrdersActionBarComponents,
			customerOrderContextMenuComponents: SirmetCustomerOrderContextMenuComponents,
		},
		production: {
			jobQueue: {
				showCatalogPartRevisionMainDocumentPreview: true,
			},
			addShopOrdersToBatchView: {
				attributeFilterFields: [1],
				showCatalogPartRevisionMainDocument: true,
				customColumns: getSirmetAddShopOrdersToBatchDataGridCustomColumns,
			},
			shopOrderBatchContextMenuComponents: SirmetShopOrderBatchContextMenuComponents,
		},
		partManagement: {
			sitePartsRowContextMenuComponents: SirmetSitePartRowContextMenuComponents,
		},
	},
};
